import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL, IPlanOmniBalanceHistoryDto } from '@/dtos';

const usePlanOmniBalanceHistoryQuery = (accountId?: number) => {
  const endDay = useMemo(() => dayjs().format(RAW_DATE_FORMAT), []);
  const startDay = useMemo(() => dayjs().subtract(18, 'month').format(RAW_DATE_FORMAT), []);

  const { data, isLoading } = useQuery(
    [API_URL.PLAN_OMNI_BALANCES_HISTORY, accountId, startDay, endDay],
    () => api.get<IPlanOmniBalanceHistoryDto[]>(API_URL.PLAN_OMNI_BALANCES_HISTORY, {
      params: {
        account_id: accountId,
        start_day: startDay,
        end_day: endDay,
      },
    }),
    {
      enabled: Boolean(accountId)
    }
  );

  const formattedData = useMemo(() => {
    return data?.data || [];
  }, [data]);

  return {
    data: formattedData,
    isLoading: isLoading,
  };
};

export default usePlanOmniBalanceHistoryQuery;
